import { Passenger } from './../../../models/passenger';
import { PNotifyService } from './../../../services/pnotify.service';
import { Journey } from './../../../models/journey';
import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../../services/auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Select2OptionData, Select2TemplateFunction } from 'ng2-select2';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import * as moment from 'moment';
import { School } from '../../../models/school';
import { info } from 'console';
import { AutofocusDirective } from 'angular-2-dropdown-multiselect/dropdown/autofocus.directive';
declare const require: any;
const jsPDF = require('jspdf');
require('jspdf-autotable');
declare const google: any;


@Component({
  selector: 'app-journey',
  templateUrl: './journey.component.html',
  styleUrls: ['./journey.component.css'],
})
export class JourneyComponent implements OnInit {

  objectKeys = Object.keys;
  objectValues = Object.values;
  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    isActive: true,
    isAssistant: false
  };

  filterJourney = {
    date: new Date(),
    inputFrom: '',
    inputTo: '',
    timeInterval: [],
  };
  JourneyloadData: any;

  time = {
    inputFrom: null,
    inputTo: null
  };
  clients: any[];
  schools: any[];
  clientsData: Array<Select2OptionData>;
  schoolsData: Array<Select2OptionData>;
  busesData: Array<Select2OptionData>;
  dayData: Array<Select2OptionData>;
  typeData: Array<Select2OptionData>;
  passengersData: Array<Select2OptionData>;
  passengersOptions: Select2Options;
  passengersAjaxOptions: any;
  passengersCurrentValue: any = 0;
  hStart: any;
  hEnd: any;
  isViewPassenger: boolean;
  buses: any[];
  journeys = {};
  js2 = {};
  journey: Journey;
  TotalJourneyPassengers: any;
  school: School;
  // Map Option
  option: any;
  map: any;
  zoneAnalyze: any = 60;
  mapView: any;
  mapData: {};
  directionsService: any;
  directionsRenderer: any;
  additionalDirectionsRenderer: any; // to draw rout when number of point > 25
  passenger: Passenger;
  notSelectedPassengerIds: any[];
  days: {};
  daysName: {};
  daysIds: any[];
  types: {};
  Object = Object;
  currentBusId = null;
  currentJourneyId = null;
  pnotify = undefined;
  modalOpen: any;
  markerBounds: any;
  markers: any[];
  dtOptions: DataTables.Settings = {};
  isResponsible = false;
  path = [];
  markerStartPosition;
  markerEndPosition;
  hasAssistent = false;
  assistent: any;
  FlagRefresh: boolean; // needed to ensure refresh time estimed before submiting
  isAdmin: boolean;
  isClient = false;
  adminStatus = true;
  positionsJourney = [];
  passagersOutOfJourney: any[] = [];

  automationLoading = false;
  automationResult: any = null;
  optimizationLoading = false;
  journeyConfig = {
    tripsPerDay: 1,
    halfDay: '',
    deleteExisting: false,
    m1Time: '07:00',
    m2Time: '12:30',
    am1Time: '14:00',
    am2Time: '16:00',
    busIds: [] as number[],
    inscriptionTypes: [] as string[]
  };
  journeyBusOptions: IMultiSelectOption[] = [];
  journeyInscriptionTypeOptions: IMultiSelectOption[] = [
    { id: 'new', name: 'Nouveau' },
    { id: 'renew', name: 'Renouvellement' },
    { id: '-', name: 'Année en cours' },
  ];
  journeyInscriptionTypeModel: string[] = [];
  optimizeConfig = {
    busId: 0
  };

   // ----- Start MultiSelect -----------
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'éléments sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // ----- End MultiSelect -----------
  // ----- Start Ion Range Slider -----------
  hourFormat = function (num) {
    if (num instanceof Date || moment.isMoment(num)) { return moment(num).format('HH:mm'); }
    const m = moment('00:00:00', 'HH:mm:ss').add(num, 'seconds');
    return m.format('HH:mm');
  };
  HMSFormat = function (num) {
    if (num instanceof Date || moment.isMoment(num)) { return moment(num).format('HH:mm:ss'); }
    const m = moment('00:00:00', 'HH:mm:ss').add(num, 'seconds');
    return m.format('HH:mm:ss');
  };
  formatX = function (time: string) {
    return moment(time, 'h:mm').format('X');
  };
  // ----- Start Ion Range Slider -----------
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------
  constructor(private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.isAdmin = (this.roleService.getRole('ROLE_ADMIN')) ? true : false;
    this.isClient = (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) ? true : false;
    this.journey = new Journey();
    this.isViewPassenger = true;
    this.days = [
      {id : 1, name: 'Lundi' },
      {id : 2, name: 'Mardi' },
      {id : 3, name: 'Mercredi' },
      {id : 4, name: 'Jeudi' },
      {id : 5, name: 'Vendredi' },
    ];
    this.daysName = {
      1: 'Lundi',
      2: 'Mardi',
      3: 'Mercredi',
      4: 'Jeudi',
      5: 'Vendredi',
    };
    this.types = {
      M1: 'Matin (Aller)',
      M2: 'Matin (Retour)',
      AM1: 'Après-midi (Aller)',
      AM2: 'Après-midi (Retour)',
    };
    /* this.dayData = [
      { id: '', text: 'Choisir un jour' },
      { id: '1', text: 'Lundi' },
      { id: '2', text: 'Mardi' },
      { id: '3', text: 'Mercredi' },
      { id: '4', text: 'Jeudi' },
      { id: '5', text: 'Vendredi' }
    ]; */
    this.typeData = [
      { id: '', text: 'Choisir un type' },
      { id: 'M1', text: 'Matin (Aller)' },
      { id: 'M2', text: 'Matin (Retour)' },
      { id: 'AM1', text: 'Après-midi (Aller)' },
      { id: 'AM2', text: 'Après-midi (Retour)' }
    ];
    this.initClientSelect();
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit() {
    this.passengersAjaxOptions = {
      url: '/api/passenger/lookup',
      dataType: 'json',
      delay: 500,
      cache: false,
      data: (params: any) => {
        return {
          search: params.term,
          gotoPage: params.page,
          pagination: true,
          isAssistant: 'false',
          isActive: 'true',
          isPositionValide: 'true',
          clientId: this.filter.clientId,
          // busIds: JSON.stringify([this.journey.busId]),
          notSelectedPassengerIds: JSON.stringify(this.notSelectedPassengerIds),
          token: localStorage.getItem('token')
        };
      },
      processResults: (data: any, params: any) => {
        params.page = params.page || 1;
        return {
          results: $.map(data.rows, function (passenger) {
            return { id: passenger.id, text: passenger.lastname, passenger: passenger };
          }),
          pagination: {
            more: (params.page * 20) < data.count
          }
        };
      },
    };

    this.passengersOptions = {
      placeholder: 'Choisir un passager',
      ajax: this.passengersAjaxOptions,
      templateResult: this.templateResult,
      // templateSelection: this.templateSelection
    };
  }
  public templateResult: Select2TemplateFunction = (state: any): JQuery | string => {
    if (!state.id) {
      return state.text;
    }
    let content = '<span style="color:green">' + state.text + '</span>';
    if (state.passenger.hasOwnProperty('Bus') && state.passenger.Bus != null) {
      if (state.passenger.Bus.id !== this.journey.busId) {
        content = '<span style="color:red">' + state.text + ' (' + state.passenger.Bus.name + ') ' + '</span>';
      } else if (state.passenger.Bus.id === this.journey.busId) {
        if (state.passenger.hasOwnProperty('JourneyPassengers')
          && state.passenger.JourneyPassengers.length > 0) {
          state.passenger.JourneyPassengers.forEach(journeyPassenger => {
            // if (journeyPassenger.Journey.day == this.journey.day && journeyPassenger.Journey.type == this.journey.type) {
             if ((journeyPassenger.Journey.J_1 == this.journey.J_1 || journeyPassenger.Journey.J_2 == this.journey.J_2 ||
            journeyPassenger.Journey.J_3 == this.journey.J_3 || journeyPassenger.Journey.J_4 == this.journey.J_4 ||
            journeyPassenger.Journey.J_5 == this.journey.J_5) && journeyPassenger.Journey.type == this.journey.type) {
              content = '<span style="color:orange">' + state.text +
                ' (' + state.passenger.Bus.name + ') ' +
                ' (' + journeyPassenger.Journey.name + ') ' +
                '</span>';
            }
          });
        }
      }
    }
    return jQuery(content);
  }

  // // public templateSelection: Select2TemplateFunction = (state: any): JQuery | string => {
  // //    if (!state.id) {
  // //      return state.text;
  // //    }
  // //    let content = '<span style="color:green">' + state.text + '</span>';
  // //    if (state.passenger.hasOwnProperty('Bus') && state.passenger.Bus.id !== this.journey.busId) {
  // //      content = '<span style="color:red">' + state.text + ' (' + state.passenger.Bus.name + ') ' + '</span>';
  // //    } else if (state.passenger.hasOwnProperty('Bus')
  // //      && state.passenger.Bus.id === this.journey.busId) {
  // //      if (state.passenger.hasOwnProperty('JourneyPassengers')
  // //        && state.passenger.JourneyPassengers.length > 0) {
  // //        state.passenger.JourneyPassengers.forEach(journeyPassenger => {
  // //          if (journeyPassenger.Journey.day == this.journey.day && journeyPassenger.Journey.type == this.journey.type) {
  // //            content = '<span style="color:orange">' + state.text +
  // //              ' (' + state.passenger.Bus.name + ') ' +
  // //              ' (' + journeyPassenger.Journey.name + ') ' +
  // //              '</span>';
  // //          }
  // //        });
  // //      }
  // //    }
  // //    return jQuery(content);
  // //  }

  initClientSelect() {
    this.filter.clientId = '';
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.adminStatus = this.authService.getUser().isRespAdmin;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        if (clients && clients.length) {
          this.filter.clientId = clients[0].id;
        }
        this.clientsData = this.clients.map((client, index) => {
          return {
            id: client.id,
            text: client.name,
            selected: this.filter.clientId == client.id ? true : false
          };
        });
        this.initSchoolSelect();
      });
    }
  }
  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect(false);
  }
  initSchoolSelect(initJourneys = true) {
    this.filter.schoolId = '';
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const school = this.authService.getUser().School;
      this.school = school;
      this.filter.schoolId = school.id;
      this.schools = [school];
      this.schoolsData = [{ id: school.id, text: school.name }];
      if (initJourneys) {
        this.initJourneys();
      }
    } else {
      let params = new HttpParams({
        fromObject: {
          clientId: this.filter.clientId
        }
      });
      this.http.get(
        '/api/school/lookup',
        { params }
      ).subscribe((schools: any[]) => {
        this.schools = schools;
        if (schools && schools.length) {
          this.filter.schoolId = schools[0].id;
          this.schoolsData = this.schools.map((school, index) => {
            if ((this.filter.schoolId === school.id)) {
              this.school = school;
            }
            return {
              id: school.id,
              text: school.name,
              selected: (this.filter.schoolId === school.id) ? true : false
            };
          });
        }
        if (initJourneys) {
          this.initJourneys();
        }
      });
    }
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
  }

  initJourneys() {
    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/journey',
      { params }
    ).subscribe((data: { buses: any[], journeys: any[] }) => {
      this.buses = data.buses;
      this.journeys = {};
      data.journeys.forEach(journey => {
        this.journeys[journey.id] = journey;
      });
      this.currentBusId = data.buses.length ? data.buses[0].id : null;
      this.currentJourneyId = data.journeys.length ? data.journeys[0].id : null;
      console.log('this.buses: ' , this.buses);
      console.log('this.journeys: ' , this.journeys);
      this.constructJS2();
      console.log('this.journeys: ' , this.js2);
    });
  }

  constructJS2() {
    this.js2 = {};
    this.buses.forEach((bus) => {
      this.js2[bus.id] = {
        bus: bus,
        journeys: {
          1: { 'M1': [], 'M2': [], 'AM1': [], 'AM2': [] },
          2: { 'M1': [], 'M2': [], 'AM1': [], 'AM2': [] },
          3: { 'M1': [], 'M2': [], 'AM1': [], 'AM2': [] },
          4: { 'M1': [], 'M2': [], 'AM1': [], 'AM2': [] },
          5: { 'M1': [], 'M2': [], 'AM1': [], 'AM2': [] },
        }
      };
    });
    /* Object.keys(this.journeys).forEach((journeyId) => {
      const journey = this.journeys[journeyId];
      this.js2[journey.busId].journeys[journey.day][journey.type].push(journey);
    }); */
    Object.keys(this.journeys).forEach((journeyId) => {
      const journey = this.journeys[journeyId];
      if (journey.J_1 == true) {
        this.js2[journey.busId].journeys[1][journey.type].push(journey);
      }

      if (journey.J_2 == true) {
        this.js2[journey.busId].journeys[2][journey.type].push(journey);
      }

      if (journey.J_3 == true) {
        this.js2[journey.busId].journeys[3][journey.type].push(journey);
      }

      if (journey.J_4 == true) {
        this.js2[journey.busId].journeys[4][journey.type].push(journey);
      }

      if (journey.J_5 == true) {
        this.js2[journey.busId].journeys[5][journey.type].push(journey);
      }
    });
    Object.keys(this.js2).forEach((busId) => {
      [1, 2, 3, 4, 5].forEach((day) => {
        ['M1', 'M2', 'AM1', 'AM2'].forEach((type) => {
          this.js2[busId].journeys[day][type].sort((a, b) => ((a.start % (24 * 3600)) > (b.start % (24 * 3600))) ? 1 : -1);
        });
      });
    });
  }

  onFilter() {
    this.initJourneys();
  }

  showAddModal(busId) {
    this.hasAssistent = false;
    this.assistent = null;
    this.journey = new Journey();
    // this.journey.day = 1;
    this.journey.type = 'M1';
    //this.journey.waitTimePassager = 45;
    this.currentBusId = busId;
    this.busesData = [{ id: this.js2[this.currentBusId].bus.id, text: this.js2[this.currentBusId].bus.name }];
    this.journey.busId = this.currentBusId;
    this.journey.JourneyPassengers = [];
    this.daysIds = [];
    this.http.get(
      '/api/bus/' + busId
    ).subscribe((bus: any) => {
      if (bus != null) {
        const assistent = bus.Passengers.map((passenger) => {
          if (passenger.isAssistant) {
            this.assistent = passenger;
          }
        });
        this.journey.startPositionLat = bus.School.lat;
        this.journey.startPositionLng = bus.School.lng;
        this.journey.endPositionLat = bus.School.lat;
        this.journey.endPositionLng = bus.School.lng;
      }
    });
    /* this.dayData = this.dayData.map((data, index) => {
      return {
        id: data.id,
        text: data.text,
        selected: Number(data.id) == this.journey.day ? true : false
      };
    }); */
    this.typeData = this.typeData.map((data, index) => {
      return {
        id: data.id,
        text: data.text,
        selected: data.id == this.journey.type ? true : false
      };
    });
    this.notSelectedPassengerIds = [];
    $('#ModalJourney').modal('show');
    this.modalOpen = 'addJourney';
    this.coloredJourneyPassengers();
    this.updateTotalJourneyPassengers();
    setTimeout(() => {
      this.initMap();
      this.map.fitBounds(this.markerBounds);
    }, 500);
  }

  showEditModal(busId, journeyId) {
    this.hasAssistent = false;
    this.assistent = null;
    this.currentBusId = busId;
    this.daysIds = [];
    this.busesData = [{ id: this.js2[this.currentBusId].bus.id, text: this.js2[this.currentBusId].bus.name }];
    this.http.get(
      '/api/journey/findOne/' + journeyId
    ).subscribe((journey: Journey) => {
      console.log(journey);
      this.journey = journey;
      this.journey.start = moment().startOf('day').add(Number(journey.start), 'seconds').toDate();
      this.journey.end = moment().startOf('day').add(Number(journey.end), 'seconds').toDate();
      this.filterJourney.inputFrom = this.journey.start;
      this.filterJourney.inputTo = this.journey.end;
      this.filterJourney.timeInterval = [this.getElapsedSecondsInDay(this.journey.start), this.getElapsedSecondsInDay(this.journey.end)];
      this.journey.JourneyPassengers.map((journeyPassenger, index) => {
        this.journey.JourneyPassengers[index].estimatedTime = moment().startOf('day').add(Number(journeyPassenger.estimatedTime), 'seconds').toDate();
      });
      /* this.dayData = this.dayData.map((data, index) => {
        return {
          id: data.id,
          text: data.text,
          selected: Number(data.id) == journey.day ? true : false
        };
      }); */

      if (this.journey.J_1) {
        this.daysIds.push(1);
      }
      if (this.journey.J_2) {
        this.daysIds.push(2);
      }
      if (this.journey.J_3) {
        this.daysIds.push(3);
      }
      if (this.journey.J_4) {
        this.daysIds.push(4);
      }
      if (this.journey.J_5) {
        this.daysIds.push(5);
      }

      this.typeData = this.typeData.map((data, index) => {
        return {
          id: data.id,
          text: data.text,
          selected: data.id == journey.type ? true : false
        };
      });
      this.notSelectedPassengerIds = this.journey.JourneyPassengers.map((obj) => {
        if (obj.Passenger.isAssistant) {
          this.hasAssistent = true;
        }
        return obj.passengerId;
      });
      this.http.get(
        '/api/bus/' + busId
      ).subscribe((bus: any) => {
        if (bus != null) {
          const assistent = bus.Passengers.map((passenger) => {
            if (passenger.isAssistant) {
              this.assistent = passenger;
            }
          });
        }
      });
      this.modalOpen = 'editJourney';
      this.coloredJourneyPassengers();
      this.updateTotalJourneyPassengers();
      setTimeout(() => {
        this.initMap();
        this.map.fitBounds(this.markerBounds);
      }, 500);
    });
  }
  showDuplicateModal(busId, journeyId) {
    this.hasAssistent = false;
    this.assistent = null;
    this.currentBusId = busId;
    this.daysIds = [];
    this.busesData = [{ id: this.js2[this.currentBusId].bus.id, text: this.js2[this.currentBusId].bus.name }];
    this.http.get(
      '/api/journey/findOne/' + journeyId
    ).subscribe((journey: Journey) => {
      this.journey = journey;
      delete this.journey.id;
      delete this.journey.name;
      this.journey.start = moment().startOf('day').add(Number(journey.start), 'seconds').toDate();
      this.journey.end = moment().startOf('day').add(Number(journey.end), 'seconds').toDate();
      this.journey.JourneyPassengers.map((journeyPassenger, index) => {
        this.journey.JourneyPassengers[index].estimatedTime = moment().startOf('day').add(Number(journeyPassenger.estimatedTime), 'seconds').toDate();
      });
      /* this.dayData = this.dayData.map((data, index) => {
        return {
          id: data.id,
          text: data.text,
          selected: Number(data.id) == journey.day ? true : false
        };
      }); */
      if (this.journey.J_1) {
        this.daysIds.push(1);
      }
      if (this.journey.J_2) {
        this.daysIds.push(2);
      }
      if (this.journey.J_3) {
        this.daysIds.push(3);
      }
      if (this.journey.J_4) {
        this.daysIds.push(4);
      }
      if (this.journey.J_5) {
        this.daysIds.push(5);
      }
      this.typeData = this.typeData.map((data, index) => {
        return {
          id: data.id,
          text: data.text,
          selected: data.id == journey.type ? true : false
        };
      });
      this.notSelectedPassengerIds = this.journey.JourneyPassengers.map((obj) => {
        if (obj.Passenger.isAssistant) {
          this.hasAssistent = true;
        }
        return obj.passengerId;
      });
      this.http.get(
        '/api/bus/' + busId
      ).subscribe((bus: any) => {
        if (bus != null) {
          const assistent = bus.Passengers.map((passenger) => {
            if (passenger.isAssistant) {
              this.assistent = passenger;
            }
          });
        }
      });
      this.journey.JourneyPassengers = this.journey.JourneyPassengers.map(function (obj) {
        delete obj.id;
        delete obj.journeyId;
        return obj;
      });
      this.modalOpen = 'addJourney';
      this.coloredJourneyPassengers();
      this.updateTotalJourneyPassengers();
      setTimeout(() => {
        this.initMap();
        this.map.fitBounds(this.markerBounds);
      }, 500);
    });
  }

  showViewModal(busId, journeyId) {
    this.currentBusId = busId;
    this.daysIds = [];
    this.busesData = [{ id: this.js2[this.currentBusId].bus.id, text: this.js2[this.currentBusId].bus.name }];

    this.http.get(
      '/api/journey/findOne/' + journeyId
    ).subscribe((journey: Journey) => {
      this.journey = journey;
      this.journey.start = moment().startOf('day').add(Number(journey.start), 'seconds').toDate();
      this.journey.end = moment().startOf('day').add(Number(journey.end), 'seconds').toDate();
      /* this.dayData = this.dayData.map((data, index) => {
        return {
          id: data.id,
          text: data.text,
          selected: Number(data.id) == journey.day ? true : false
        };
      }); */
      if (this.journey.J_1) {
        this.daysIds.push(1);
      }
      if (this.journey.J_2) {
        this.daysIds.push(2);
      }
      if (this.journey.J_3) {
        this.daysIds.push(3);
      }
      if (this.journey.J_4) {
        this.daysIds.push(4);
      }
      if (this.journey.J_5) {
        this.daysIds.push(5);
      }
      this.typeData = this.typeData.map((data, index) => {
        return {
          id: data.id,
          text: data.text,
          selected: data.id == journey.type ? true : false
        };
      });
      this.notSelectedPassengerIds = this.journey.JourneyPassengers.map(function (obj) {
        return obj.passengerId;
      });
      $('#ModalJourney').modal('show');
      this.modalOpen = 'viewJourney';
      this.coloredJourneyPassengers();
      this.updateTotalJourneyPassengers();
      setTimeout(() => {
        this.initMap();
        this.map.fitBounds(this.markerBounds);
      }, 500);
    });
  }

  dayChanged(e: any) {
    // this.journey.day = e.value;

    if (this.daysIds.includes(1)) {
      this.journey.J_1 = true;
    } else {
      this.journey.J_1 = false;
    }

    if (this.daysIds.includes(2)) {
      this.journey.J_2 = true;
    } else {
      this.journey.J_2 = false;
    }

    if (this.daysIds.includes(3)) {
      this.journey.J_3 = true;
    } else {
      this.journey.J_3 = false;
    }

    if (this.daysIds.includes(4)) {
      this.journey.J_4 = true;
    } else {
      this.journey.J_4 = false;
    }

    if (this.daysIds.includes(5)) {
      this.journey.J_5 = true;
    } else {
      this.journey.J_5 = false;
    }

  }

  typeChanged(e: any) {
    this.journey.type = e.value;
    this.refreshMap();
  }

  changeJourneyStart() {
    const start = Math.floor(new Date(this.journey.start).getTime());
    const end = Math.floor(new Date(this.journey.end).getTime());
    this.calculateAndDisplayRoute();
    if (start > end) {
      this.journey.end = '';
    }
  }

  changeJourneyEnd() {
    const start = Math.floor(new Date(this.journey.start).getTime());
    const end = Math.floor(new Date(this.journey.end).getTime());
    if (start > end) {
      this.journey.start = '';
    }
  }


  changeHistoryJourney(){
    const inputFrom = this.getElapsedSecondsInDay(this.filterJourney.inputFrom);
    const inputTo   = this.getElapsedSecondsInDay(this.filterJourney.inputTo);
    if (inputFrom > inputTo) {
      this.filterJourney.inputTo = '';
    } else {
      this.filterJourney.timeInterval = [inputFrom, inputTo];
    }
  }

  getDataFromBus(id) {
    return function (element) {
      return element.busId === id;
    };
  }

  onFilterJourney() {
    this.JourneyloadData = true;
    this.positionsJourney = [];
    this.refreshMap();

    let params = new HttpParams({
      fromObject: {
        schoolId: this.filter.schoolId + '',
        busIds: JSON.stringify([this.journey.busId]),
        date: moment(this.filterJourney.date).format('YYYY-MM-DD'),
        timeInterval: JSON.stringify(this.filterJourney.timeInterval)
      }
    });
    let url = '/api/bus/mapJourney';

    this.http.get(url, { params })
        .subscribe(
          (data: any) => {

            if (!data.positions.length) {
              this.JourneyloadData = false;
            }
            for (let index = 0; index < data.buses.length; index++) {
              const positions = data.positions.filter(this.getDataFromBus(data.buses[index].id));
              this.positionsJourney = positions;
              if (positions.length > 0) {
                const color = '#34495e';
                const JourneyPassengers = [];// only to have journey without markers in the map
                this.createLineBus(data.buses[index], positions, this.map, color,JourneyPassengers);
              }

            }
            this.map.fitBounds(this.markerBounds);
          },
          error => {
            this.JourneyloadData = false;
          }
        );

  }

  createLineBus(bus, locations, map, color,JourneyPassengers) {
    const infowindow = new google.maps.InfoWindow();
    const path = [];
    let exist, tempDistance;

    var passengers = [];
    JourneyPassengers.forEach((journeyPassenger) => {
      passengers.push(journeyPassenger.Passenger);
    });
    
    for (let i = 0; i < locations.length; i++) {
      const isFirst = i === 0 ? true : false;
      const isLast = i === locations.length - 1 ? true : false;

      const pos = new google.maps.LatLng(parseFloat(locations[i].lat), parseFloat(locations[i].lng));
      // Because path is an MVCArray, we can simply append a new coordinate
      // and it will automatically appear.
      path.push(pos);

      let content = '';
      let label = null;
      let icon = null;
      if (isFirst && i === 0) {
        content = '<h1 style="text-align: center;">Départ</h1>';
        label = 'JD';
      } else if (isLast && i === locations.length - 1) {
        content = '<h1 style="text-align: center;">Arrivée</h1>';
        label = 'JA';
      } else if (locations[i].speed === 0) {
        icon = {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 6,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            fillColor: '#F00',
            fillOpacity: 0.9
        };
      } else {
        icon = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 3.5,
            strokeColor: '#ffffff',
            strokeWeight: 1,
            fillColor: color,
            fillOpacity: 0.9,
            rotation: locations[i].angle
        };
      }

      exist = false;

      // Affiche les marker in raduis si la demande est order depuis historique si non affiche tout les markers
      if (passengers.length > 0) {
        // check if the positon is in raduis of one of passengers
        for (let j = 0; j < passengers.length; j++) {
          tempDistance = this.getDistanceInMeter(passengers[j].lat, passengers[j].lng,locations[i].lat,locations[i].lng);
          if (tempDistance < parseInt(this.zoneAnalyze, 10)){
            exist = true;
            //console.log ("Position in ==> "+i);
          }
        }
      } else {
        exist = true;
      }
      
      
      if (exist === true || (isFirst && i === 0) || (isLast && i === locations.length - 1)) {
        // window.alert(locations[i].angle);
        const marker = new google.maps.Marker({
          position: pos,
          map: map,
          label: label,
          icon: icon
        });
        this.markerBounds.extend(pos);

        const this_ = this;
        marker.addListener('click', function () {
          const position = locations[i].lat + ',' + locations[i].lng;

          content = `<b>Bus :</b> ${bus.name}<br/>
          <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
          <b>Position :</b> ${position} <br/>
          <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

          content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';

          infowindow.setContent(content);
          infowindow.open(map, marker);
        });

        marker.addListener('mouseover', function() {
        content = `<b>Bus :</b> ${bus.name}<br/>
        <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

        content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';

        infowindow.setContent(content);
        infowindow.open(map, marker);
        });
        marker.addListener('mouseout', function() {
        infowindow.close();
        });
      }
      

      if (isLast) {
        this.JourneyloadData = false;
      }
    }
    const poly = new google.maps.Polyline({
      path: path,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 3,
    });
    poly.setMap(map);

  }

  onAddJourney() {
    const messages = this.checksForJourney();
    if (messages != '') {
      this.pnotify.error({
        title: 'Confirmation',
        text: messages,
        width: '500px',
        addClass: '',
        stack: {
          firstpos1: 70, firstpos2: 10,
          modal: true,
          overlay_close: true
        },
        hide: false,
        modules: {
          Confirm: {
            confirm: true,
            buttons: [
              {
                text: 'Confirmer',
                addClass: 'btn btn-chico',
                click: notice => {
                  this.addJourney();
                  notice.close();
                }
              },
              {
                text: 'Annuler',
                addClass: 'btn btn-default',
                click: (notice) => {
                  notice.close();
                  notice.fire('pnotify.cancel', { notice });
                }
              }
            ]
          }
        }
      });
    } else {
      this.addJourney();
    }
  }

  addJourney() {
    this.journey.start = this.getElapsedSecondsInDay(this.journey.start);
    this.journey.end = this.getElapsedSecondsInDay(this.journey.end);
    this.journey.JourneyPassengers.forEach((journeyPassenger, index) => {
      this.journey.JourneyPassengers[index].estimatedTime = this.getElapsedSecondsInDay(journeyPassenger.estimatedTime);
      journeyPassenger.order = index + 1;
    });
    this.http.post(
      '/api/journey/0',
      { journey: this.journey }
    ).subscribe(
      (journey: Journey) => {
        if (journey) {
          this.currentBusId = journey.busId;
          this.currentJourneyId = journey.id;
          this.journeys[journey.id] = journey;
          this.constructJS2();
          this.journey = journey;
          this.daysIds = [];
          // this.journey.start = new Date(Number(journey.start) * 1000);
          // this.journey.end = new Date(Number(journey.end) * 1000);
          /* this.dayData = this.dayData.map((data, index) => {
            return {
              id: data.id,
              text: data.text,
              selected: Number(data.id) == journey.day ? true : false
            };
          }); */
          if (this.journey.J_1) {
            this.daysIds.push(1);
          }
          if (this.journey.J_2) {
            this.daysIds.push(2);
          }
          if (this.journey.J_3) {
            this.daysIds.push(3);
          }
          if (this.journey.J_4) {
            this.daysIds.push(4);
          }
          if (this.journey.J_5) {
            this.daysIds.push(5);
          }
          this.typeData = this.typeData.map((data, index) => {
            return {
              id: data.id,
              text: data.text,
              selected: data.id == journey.type ? true : false
            };
          });
          this.modalOpen = 'viewJourney';
          this.coloredJourneyPassengers();
          this.updateTotalJourneyPassengers();
          setTimeout(() => {
            this.initMap();
            this.map.fitBounds(this.markerBounds);
          }, 500);
        }
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }
  onEditJourney() {
    const messages = this.checksForJourney();
    if (messages != '') {
      this.pnotify.error({
        title: 'Confirmation',
        text: messages,
        width: '500px',
        addClass: '',
        stack: {
          firstpos1: 70, firstpos2: 10,
          modal: true,
          overlay_close: true
        },
        hide: false,
        modules: {
          Confirm: {
            confirm: true,
            buttons: [
              {
                text: 'Confirmer',
                addClass: 'btn btn-chico',
                click: notice => {
                  this.editJourney();
                  notice.close();
                }
              },
              {
                text: 'Annuler',
                addClass: 'btn btn-default',
                click: (notice) => {
                  notice.close();
                  notice.fire('pnotify.cancel', { notice });
                }
              }
            ]
          }
        }
      });
    } else {
      this.editJourney();
    }
  }
  editJourney(): void {
    this.journey.start = this.getElapsedSecondsInDay(this.journey.start);
    this.journey.end = this.getElapsedSecondsInDay(this.journey.end);
    this.journey.JourneyPassengers.forEach((journeyPassenger, index) => {
      this.journey.JourneyPassengers[index].estimatedTime = this.getElapsedSecondsInDay(journeyPassenger.estimatedTime);
      journeyPassenger.order = index + 1;
    });
    this.http.put(
      '/api/journey/' + this.journey.id,
      { journey: this.journey }
    ).subscribe(
      (journey: Journey) => {
        if (journey) {
          this.currentBusId = journey.busId;
          this.currentJourneyId = journey.id;
          this.journeys[journey.id] = journey;
          this.constructJS2();
          this.journey = journey;
          this.daysIds = [];
          // this.journey.start = new Date(Number(journey.start) * 1000);
          // this.journey.end = new Date(Number(journey.end) * 1000);
          /* this.dayData = this.dayData.map((data, index) => {
            return {
              id: data.id,
              text: data.text,
              selected: Number(data.id) == journey.day ? true : false
            };
          }); */
          if (this.journey.J_1) {
            this.daysIds.push(1);
          }
          if (this.journey.J_2) {
            this.daysIds.push(2);
          }
          if (this.journey.J_3) {
            this.daysIds.push(3);
          }
          if (this.journey.J_4) {
            this.daysIds.push(4);
          }
          if (this.journey.J_5) {
            this.daysIds.push(5);
          }
          this.typeData = this.typeData.map((data, index) => {
            return {
              id: data.id,
              text: data.text,
              selected: data.id == journey.type ? true : false
            };
          });
          this.modalOpen = 'viewJourney';
          this.coloredJourneyPassengers();
          this.updateTotalJourneyPassengers();
          setTimeout(() => {
            this.initMap();
            this.map.fitBounds(this.markerBounds);
          }, 500);
        }
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

  onDeleteJourney(journey) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          focus: false,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.deleteJourney(journey);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }
  deleteJourney(journey) {
    this.http
      .delete('/api/journey/' + journey.id)
      .subscribe(result => {
        delete this.journeys[journey.id];
        this.constructJS2();
        $('#ModalJourney').modal('hide');
      },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                focus: false,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  passengerChanged(e: any) {
    if (e.value != null) {
      this.http.get(
        '/api/passenger/findOne/' + e.value
      ).subscribe((passenger: Passenger) => {
        this.passenger = passenger;
        this.passengersCurrentValue = e.value;
        this.passengersData = [{ id: e.value, text: e.data[0].text }];
      });
    }
  }

  passengerMapSelected(id: any, lastname: any) {
    if (id != null) {
      this.http.get(
        '/api/passenger/findOne/' + id
      ).subscribe((passenger: Passenger) => {
        this.passenger = passenger;
        this.passengersCurrentValue = id;
        this.passengersData = [{ id: id, text: lastname }];
      });
    }
  }

  clearPassengerSelection() {
    this.passengersCurrentValue = 0;
    this.passengersData = [];
  }

  addPassanger(journyId) {
    if (this.journey.JourneyPassengers.length < 49){ // max 2 trajet de 25 arrets sont supporter dans cette version de code
      this.journey.JourneyPassengers.push({
        passengerId: this.passenger.id,
        Passenger: this.passenger,
        order: this.journey.JourneyPassengers.length + 1,
        estimatedTime: 0,
      });
      this.notSelectedPassengerIds = this.journey.JourneyPassengers.map(function (obj) {
        return obj.passengerId;
      });
      this.passengersCurrentValue = 0;
      this.passengersData = [];
      this.coloredJourneyPassengers();
      this.FlagRefresh = true;
    } else {
      this.pnotify.error({
        title: 'Information',
        text: "Le trajet est limité à 49 arrêts",
        width: '500px',
        addClass: '',
        stack: {
          firstpos1: 70, firstpos2: 10,
          modal: true,
          overlay_close: true
        },
        hide: false,
        modules: {
          Confirm: {
            confirm: true,
            buttons: [
              {
                text: 'Ok',
                addClass: 'btn btn-chico',
                click: notice => {
                  notice.close();
                }
              }
            ]
          }
        }
      });
    }
  }

  deletePassenger(index) {
    this.journey.JourneyPassengers.splice(index, 1);
    this.journey.JourneyPassengers.forEach((journeyPassenger, i) => {
      journeyPassenger.order = i + 1;
    });
    this.FlagRefresh = true;
  }
  addAssitante() {
    if (this.journey.JourneyPassengers.length < 49){

      this.journey.JourneyPassengers.push({
        passengerId: this.assistent.id,
        Passenger: this.assistent,
        order: this.journey.JourneyPassengers.length + 1,
        estimatedTime: 0,
      });
      this.notSelectedPassengerIds = this.journey.JourneyPassengers.map(function (obj) {
        return obj.passengerId;
      });
      this.hasAssistent = true;
      this.coloredJourneyPassengers();
      this.FlagRefresh = true;
     } else {
      this.pnotify.error({
        title: 'Information',
        text: "Le trajet est limité à 49 arrêt",
        width: '500px',
        addClass: '',
        stack: {
          firstpos1: 70, firstpos2: 10,
          modal: true,
          overlay_close: true
        },
        hide: false,
        modules: {
          Confirm: {
            confirm: true,
            buttons: [
              {
                text: 'Ok',
                addClass: 'btn btn-chico',
                click: notice => {
                  notice.close();
                }
              }
            ]
          }
        }
      });
    }
  }

  removeAssitante() {
    this.journey.JourneyPassengers.forEach((journeyPassenger, i) => {
      if (journeyPassenger.Passenger.isAssistant == true) {
        this.journey.JourneyPassengers.splice(i, 1);
        this.hasAssistent = false;
      }
    });
    this.journey.JourneyPassengers.forEach((journeyPassenger, i) => {
      journeyPassenger.order = i + 1;
    });
    this.FlagRefresh = true;
  }

  addAllPassengers(journyId) {
    // Ajouter les passagers dans le tableau du trajet en cours depuis la liste des passager non affecter
    for (let i = 0; i < this.passagersOutOfJourney.length; i++) {
      this.http.get(
        '/api/passenger/findOne/' + this.passagersOutOfJourney[i].id
      ).subscribe((passenger: Passenger) => {
        this.passenger = passenger;

        //console.log("this.passenger.lastname ",this.passenger.lastname);
        
        if (this.journey.JourneyPassengers.length < 49){ // max 2 trajet de 25 arrets sont supporter dans cette version de code
          this.journey.JourneyPassengers.push({
            passengerId: this.passenger.id,
            Passenger: this.passenger,
            order: this.journey.JourneyPassengers.length + 1,
            estimatedTime: 0,
          });
          this.notSelectedPassengerIds = this.journey.JourneyPassengers.map(function (obj) {
            return obj.passengerId;
          });
          
          this.coloredJourneyPassengers();
          this.FlagRefresh = true;
          } else {
            this.pnotify.error({
              title: 'Information',
              text: "Le trajet est limité à 49 arrêts",
              width: '500px',
              addClass: '',
              stack: {
                firstpos1: 70, firstpos2: 10,
                modal: true,
                overlay_close: true
              },
              hide: false,
              modules: {
                Confirm: {
                  confirm: true,
                  buttons: [
                    {
                      text: 'Ok',
                      addClass: 'btn btn-chico',
                      click: notice => {
                        notice.close();
                      }
                    }
                  ]
                }
              }
            });
          }
      });
      
    }

  }

  onOrderChange(oldIdx, e) {
    const newIndex = Number(e.target.value) - 1;
    this.moveElemetInArray(this.journey.JourneyPassengers, oldIdx, newIndex);
    this.journey.JourneyPassengers.forEach((journeyPassenger, index) => {
      journeyPassenger.order = index + 1;
    });
    this.FlagRefresh = true;
  }

  refreshMap() {
    this.initMap();
    this.map.fitBounds(this.markerBounds);
    this.updateTotalJourneyPassengers();
    this.FlagRefresh = false;
  }
  coloredJourneyPassengers() {
    this.journey.JourneyPassengers.forEach((journeyPassenger, index) => {
      if (journeyPassenger.Passenger.isAssistant) {
        journeyPassenger.color = 'p-blue';
      } else {
        journeyPassenger.color = ''; // p-green
        if (journeyPassenger.Passenger.hasOwnProperty('Bus') && journeyPassenger.Passenger.Bus != null) {
          if (journeyPassenger.Passenger.Bus.id !== this.journey.busId) {
            journeyPassenger.color = 'p-red';
          } else if (journeyPassenger.Passenger.Bus.id === this.journey.busId) {
            if (journeyPassenger.Passenger.hasOwnProperty('JourneyPassengers')
              && journeyPassenger.Passenger.JourneyPassengers.length > 0) {
              journeyPassenger.Passenger.JourneyPassengers.forEach(_journeyPassenger => {
                if ((this.journey.J_1 == _journeyPassenger.Journey.J_1 || this.journey.J_2 == _journeyPassenger.Journey.J_2 ||
                    this.journey.J_3 == _journeyPassenger.Journey.J_3 || this.journey.J_4 == _journeyPassenger.Journey.J_4 ||
                    this.journey.J_5 == _journeyPassenger.Journey.J_5) && _journeyPassenger.Journey.type == this.journey.type) {
                  journeyPassenger.color = 'p-orange';
                }
              });
            }
          }
        }
      }
    });
  }


  checksForJourney() {
    let messages = '';
    // check intersection horaire entre les trajets
    Object.keys(this.journeys).forEach((journeyId) => {
      const journey = this.journeys[journeyId];
      // Description du check: Trajet diff ET Bus diff ET (Partage aumoin une journe active (=1))
      if (this.journey.id != journey.id && this.journey.busId == journey.busId &&
        ((this.journey.J_1 == journey.J_1 && journey.J_1 == 1) || (this.journey.J_2 == journey.J_2 && journey.J_2 == 1)||
        (this.journey.J_3 == journey.J_3 && journey.J_3 == 1) || (this.journey.J_4 == journey.J_4 && journey.J_4 == 1) ||
        (this.journey.J_5 == journey.J_5 && journey.J_1 == 1))) {
        const aStart = this.hourFormat(journey.start);
        const aEnd = this.hourFormat(journey.end);
        const bStart = this.hourFormat(this.journey.start);
        const bEnd = this.hourFormat(this.journey.end);
        // if (!(aEnd > aStart && bEnd > bStart && (bStart >= aEnd || aStart >= bEnd))) {
        if (!(bStart >= aEnd || aStart >= bEnd)) {
          messages += `Intersection avec le trajet : ${journey.name}  -  ${this.hourFormat(journey.start)} / ${this.hourFormat(journey.end)} \n`;
        }
      }
    });
    // check la charge maximale de bus
    let countPassanger = 0;
    this.journey.JourneyPassengers.forEach((journeyPassenger) => {
      countPassanger = countPassanger + journeyPassenger.Passenger.count;
    });
    this.buses.forEach((bus) => {
      if (bus.id == this.currentBusId) {
        if (countPassanger > bus.maxLoad) {
          messages += `La charge actuelle (${countPassanger}) dépasse la charge maximale (${bus.maxLoad})\n`;
        }
      }
    });
    // check si passenger est affecté à 1 ou plusieur trajets du meme type
    this.journey.JourneyPassengers.forEach((journeyPassenger) => {
      Object.keys(this.journeys).forEach((journeyId) => {
        const journey = this.journeys[journeyId];
        // Description du check: Trajet diff ET meme Bus ET (Partage aumoin une journe active (=1)) ET meme type de trajet
        if (this.journey.id != journey.id &&
          this.journey.busId == journey.busId && ((this.journey.J_1 == journey.J_1 && journey.J_1 == 1) || (this.journey.J_2 == journey.J_2 && journey.J_2 == 1)||
          (this.journey.J_3 == journey.J_3 && journey.J_3 == 1) || (this.journey.J_4 == journey.J_4 && journey.J_4 == 1) ||
          (this.journey.J_5 == journey.J_5 && journey.J_5 == 1)) && this.journey.type == journey.type) {
          journey.JourneyPassengers.forEach((_journeyPassenger) => {
            if (journeyPassenger.Passenger.id == _journeyPassenger.Passenger.id) {
              messages += `Le passager "${_journeyPassenger.Passenger.lastname}" est déjà associé au trajet "${journey.name} - ${journey.type}" \n`;
            }
          });
        }
      });
    });
    // check si passenger est deja associé a un autre bus
    this.journey.JourneyPassengers.forEach((journeyPassenger) => {
      if (journeyPassenger.Passenger.busId != this.currentBusId) {
        messages += `Le passager "${journeyPassenger.Passenger.lastname}" est déjà associé au bus "${journeyPassenger.Passenger.Bus.name}" \n`;
      }
    });

    return messages;
  }

  moveElemetInArray(arr: any[], oldIdx: number, newIdx: number) {
    if (oldIdx >= 0 && oldIdx <= arr.length &&
      newIdx >= 0 && newIdx <= arr.length &&
      oldIdx != newIdx) {
      const element = arr[oldIdx];
      arr.splice(oldIdx, 1);// remove data from old index of array
      arr.splice(newIdx, 0, element);// add new data to the new index of array
    }
  }

  initMap() {
    this.directionsService = new google.maps.DirectionsService;
    this.directionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    this.additionalDirectionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    
    const center = { lat: Number(this.school.lat), lng: Number(this.school.lng) };
    this.option = {
      center: center,
      zoom: 8,
      gestureHandling: 'cooperative'
    };
    let map;
    switch (this.modalOpen) {
      case 'addJourney':
        map = new google.maps.Map(document.getElementById('journey-map'), this.option);
        break;
      case 'editJourney':
        map = new google.maps.Map(document.getElementById('journey-map-edit'), this.option);
        break;
      case 'viewJourney':
        map = new google.maps.Map(document.getElementById('journey-map-view'), this.option);
        break;
      default:
        map = new google.maps.Map(document.getElementById('journey-map'), this.option);
        break;
    }
    this.map = map;
    this.directionsRenderer.setMap(map);
    this.additionalDirectionsRenderer.setMap(map);
    this.markerBounds = new google.maps.LatLngBounds();
    this.markers = [];
    const marker = new google.maps.Marker({
      position: { lat: Number(this.school.lat), lng: Number(this.school.lng) },
      map: this.map,
      zIndex: 1,
      icon: 'assets/images/markers/school.png',
    });
    this.journey.startPositionLat = (this.journey.startPositionLat != '') ? this.journey.startPositionLat + '' : this.school.lat + '';
    this.journey.startPositionLng = (this.journey.startPositionLng != '') ? this.journey.startPositionLng + '' : this.school.lng + '';
    this.journey.endPositionLat = (this.journey.endPositionLat != '') ? this.journey.endPositionLat + '' : this.school.lat + '';
    this.journey.endPositionLng = (this.journey.endPositionLng != '') ? this.journey.endPositionLng + '' : this.school.lng + '';
    this.markerStartPosition = new google.maps.Marker({
      position: { lat: Number(this.journey.startPositionLat), lng: Number(this.journey.startPositionLng) },
      map: this.map,
      label: 'D',
      zIndex: 3,
      draggable: (this.modalOpen != 'viewJourney') ? true : false
    });
    this.markerEndPosition = new google.maps.Marker({
      position: { lat: Number(this.journey.endPositionLat), lng: Number(this.journey.endPositionLng) },
      map: this.map,
      label: 'A',
      zIndex: 2,
      draggable: (this.modalOpen != 'viewJourney') ? true : false
    });
    google.maps.event.addListener(this.markerStartPosition, 'dragend', (e) => {
      this.journey.startPositionLat = e.latLng.lat();
      this.journey.startPositionLng = e.latLng.lng();
    });
    google.maps.event.addListener(this.markerEndPosition, 'dragend', (e) => {
      this.journey.endPositionLat = e.latLng.lat();
      this.journey.endPositionLng = e.latLng.lng();
    });
    this.markerBounds.extend({ lat: Number(this.journey.startPositionLat), lng: Number(this.journey.startPositionLng) });
    this.markerBounds.extend({ lat: Number(this.journey.endPositionLat), lng: Number(this.journey.endPositionLng) });
    this.markerBounds.extend({ lat: Number(this.school.lat), lng: Number(this.school.lng) });
    this.addOrDeleteMarkers(this.journey.JourneyPassengers);
  }

  addOrDeleteMarkers(JourneyPassengers) {
    this.path = [];
    this.path.push({ lat: Number(this.journey.startPositionLat), lng: Number(this.journey.startPositionLng) });
    for (let i = 0; i < JourneyPassengers.length; i++) {
      this.setMarker(i + 1, JourneyPassengers[i]);
    }
    this.path.push({ lat: Number(this.journey.endPositionLat), lng: Number(this.journey.endPositionLng) });
    this.displayPassagerOutOfJourney(JourneyPassengers);
    this.calculateAndDisplayRoute();
    // const poly = new google.maps.Polyline({
    //   path: this.path,
    //   geodesic: true,
    //   strokeColor: '#3498db',
    //   strokeOpacity: 0.8,
    //   strokeWeight: 3,
    //   icons: [{
    //     icon: { path: google.maps.SymbolPath.FORWARD_OPEN_ARROW },
    //     offset: '10%',
    //     repeat: '500px'
    //   }]
    // });
    // poly.setMap(this.map);
  }

  setMarker(index, journeyPassenger) {
    const pos = new google.maps.LatLng(journeyPassenger.Passenger.lat, journeyPassenger.Passenger.lng);
    let icon = '';

    if (journeyPassenger.Passenger.isAssistant) {
      icon = 'assets/images/markers/Assistant_Home1.png';
    } else {
      icon = 'assets/images/markers/passenger1.png';
    }
    let content = `<b>Nom : </b>${journeyPassenger.Passenger.lastname}<br />
    <b>Prénom(s) : </b>${journeyPassenger.Passenger.firstnames}<br />
    <b>Nombre de passager : </b>${journeyPassenger.Passenger.count}<br />
    <b>Abonnement : </b>${journeyPassenger.Passenger.subscription}<br />`;

    const Infowindow = new google.maps.InfoWindow({
      /* content: '<b>Nom & Prénoms: </b>' + journeyPassenger.Passenger.lastname + ' ' + journeyPassenger.Passenger.firstnames +
      '<br />' + '<b>Nombre de passager : </b>' + journeyPassenger.Passenger.count +
      '<b>Abonnement : </b>${passenger.subscription}<br />'*/
      content: content
    });
    const marker = new google.maps.Marker({
      position: pos,
      map: this.map,
      label: index + '',
      icon: icon,
    });
    marker.addListener('mouseover', function () {
      Infowindow.open(this.map, marker);
    });
    marker.addListener('mouseout', function () {
      Infowindow.close();
    });
    this.markers.push(marker);
    this.path.push(pos);
    this.markerBounds.extend(pos);
    // const poly = new google.maps.Polyline({
    //   path: this.path,
    //   geodesic: true,
    //   strokeColor: '#3498db',
    //   strokeOpacity: 0.8,
    //   strokeWeight: 3,
    //   icons: [{
    //     icon: { path: google.maps.SymbolPath.FORWARD_OPEN_ARROW },
    //     offset: '10%',
    //     repeat: '500px'
    //   }]
    // });
    // poly.setMap(this.map);
  }

  setMarkerOOjourney(OOjourneyPassenger) {
    const pos = new google.maps.LatLng(OOjourneyPassenger.lat, OOjourneyPassenger.lng);
    const marker = new google.maps.Marker({
      position: pos,
      map: this.map,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 9,
        fillColor: (OOjourneyPassenger.isAffected) ? '#FF3232' : '#00b300',
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: '#fff',
      },
    });
    let status: any;

    if (OOjourneyPassenger.isAffected) {
      status = 'Affecté au trajet ' + OOjourneyPassenger.AffectedBus;
    } else {
      status = 'Libre';
    }

    let content = `<b>Nom : </b>${OOjourneyPassenger.lastname}<br />
    <b>Prénom(s) : </b>${OOjourneyPassenger.firstnames}<br />
    <b>Nombre de passager : </b>${OOjourneyPassenger.count}<br />
    <b>Abonnement : </b>${OOjourneyPassenger.subscription}<br />
    <b>Status : </b>${status}<br />`;

    const Infowindow = new google.maps.InfoWindow({
      /* content: '<b>Nom & Prénoms: </b>' + OOjourneyPassenger.lastname + ' ' + OOjourneyPassenger.firstnames + '<br />' +
      '<b>Nombre de passager : </b>' + OOjourneyPassenger.count + '<br />' +
      '<b>Status : </b>' + status */
      content: content
    });

    marker.addListener('mouseover', function () {
      Infowindow.open(this.map, marker);
    });

    marker.addListener('mouseout', function () {
      Infowindow.close();
    });

    const that = this; // use 'that' variable instead of this to call passengerMapSelected from marker class
    marker.addListener('click', function () {
      if (this.modalOpen != 'viewJourney') {
        that.passengerMapSelected(OOjourneyPassenger.id, OOjourneyPassenger.lastname);
      }
    });

    this.markerBounds.extend(pos);
  }

  deleteMarkers() {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];
  }

  async calculateAndDisplayRoute() {
    
    // this.markers.forEach((marker) => {
    //   waypts.push({
    //     location: marker.getPosition(),
    //     stopover: true
    //   });
    // });

    //1- Divide route to several parts because max stations limit is 25 (23 waypoints + 1 origin + 1 destination)
    for (var i = 0, markersparts = [], max = 25 - 1; i < this.markers.length; i = i + max)
      markersparts.push(this.markers.slice(i, i + max + 1));
    
    console.log('markersparts');
    console.log(markersparts);
    var totalLegs = [];

    for (var i = 0; i < markersparts.length; i++) {
        var waypts = [];
        var origine, destination;

        if (markersparts.length > 1){

          if (i == 0){
            origine = { lat: Number(this.journey.startPositionLat), lng: Number(this.journey.startPositionLng) };
            destination = { lat: Number(markersparts[i][max].getPosition().lat()), lng: Number(markersparts[i][max].getPosition().lng()) };
            for (var j = 0; j <= markersparts[i].length - 2; j++) {
              waypts.push({location: markersparts[i][j].getPosition(), stopover: true}); 
            }
          } else if (i == markersparts.length - 1){
            origine = { lat: Number(markersparts[i][0].getPosition().lat()), lng: Number(markersparts[i][0].getPosition().lng()) };
            destination = { lat: Number(this.journey.endPositionLat), lng: Number(this.journey.endPositionLng) };
            for (var j = 1; j <= markersparts[i].length - 1; j++) {
              waypts.push({location: markersparts[i][j].getPosition(), stopover: true}); 
            }
          }
  
        } else {
          
          origine = { lat: Number(this.journey.startPositionLat), lng: Number(this.journey.startPositionLng) };
          destination = { lat: Number(this.journey.endPositionLat), lng: Number(this.journey.endPositionLng) };
          for (var j = 0; j <= markersparts[i].length - 1; j++)
              waypts.push({location: markersparts[i][j].getPosition(), stopover: true});

        }

      var response;

      await this.routeInfo(origine,destination,waypts,i).then((resolve => {
        
        response = resolve;
        let route = response.routes[0];
        for (var z = 0; z <= route.legs.length - 1; z++)
          totalLegs.push (route.legs[z]);

        console.log('i'+i);
        console.log('markersparts.length'+markersparts.length);
        console.log('totalLegs');
        console.log(totalLegs);

        if (i == markersparts.length - 1){
          
          var distancetrajet: any = 0;
          var TimeEstimatedPassager: any = this.getElapsedSecondsInDay(this.journey.start);
          console.log(distancetrajet);

          if (this.journey.type === ('M1' || 'AM1')) {
            this.journey.waitTimePassager = 20; // 20 second
          } else {
            this.journey.waitTimePassager = 0;
          }
    
          // Calcule: Temps estimé de fin de trajet / Arrivé a chaque arret / distance total estimé
          if (this.modalOpen !== 'viewJourney' && totalLegs.length > 0) {
            let route = response.routes[0];
            // 1- Ajouter la distance et la durée du point depart au premier passager
            distancetrajet = distancetrajet + totalLegs[0].distance.value;
            TimeEstimatedPassager = TimeEstimatedPassager + totalLegs[0].duration.value;
            console.log(distancetrajet);
            this.journey.JourneyPassengers[0].estimatedTime = moment().startOf('day').add(TimeEstimatedPassager, 'seconds').toDate();
            // 2- Ajouter la distance et la durée pour chaque point d'arret
            for (let i = 1; i <= totalLegs.length - 2; i++) {
              distancetrajet = distancetrajet + totalLegs[i].distance.value;
              TimeEstimatedPassager = TimeEstimatedPassager + totalLegs[i].duration.value + this.journey.waitTimePassager;
              this.journey.JourneyPassengers[i].estimatedTime = moment().startOf('day').add(TimeEstimatedPassager, 'seconds').toDate();
              console.log(distancetrajet);
            }
            // 3- Ajouter la distance et la durée pour aller au point destinations
            distancetrajet = distancetrajet + totalLegs[totalLegs.length - 1].distance.value;
            TimeEstimatedPassager = TimeEstimatedPassager + totalLegs[totalLegs.length - 1].duration.value;
            console.log(distancetrajet);
          
            this.journey.distance = Number((distancetrajet / 1000).toFixed(0));
            this.journey.end = moment().startOf('day').add(TimeEstimatedPassager, 'seconds').toDate();
          }
        }
      }));

    }


    /* this.directionsService.route({
      origin: { lat: Number(this.journey.startPositionLat), lng: Number(this.journey.startPositionLng) },
      destination: { lat: Number(this.journey.endPositionLat), lng: Number(this.journey.endPositionLng) },
      waypoints: waypts,
      optimizeWaypoints: false,// true
      travelMode: 'DRIVING'
    }, (response, status) => {
      var distancetrajet: any = 0;
      var TimeEstimatedPassager: any = this.getElapsedSecondsInDay(this.journey.start);

      if (this.journey.type === ('M1' || 'AM1')) {
        this.journey.waitTimePassager = 20; // 20 second
      } else {
        this.journey.waitTimePassager = 0;
      }
      if (status === 'OK') {
        this.directionsRenderer.setDirections(response);
        // Calcule: Temps estimé de fin de trajet / Arrivé a chaque arret / distance total estimé
        if (this.modalOpen !== 'viewJourney' && waypts.length > 0) {
          let route = response.routes[0];
          // 1- Ajouter la distance et la durée du point depart au premier passager
          distancetrajet = distancetrajet + route.legs[0].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[0].duration.value;
          this.journey.JourneyPassengers[0].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          // 2- Ajouter la distance et la durée pour chaque point d'arret
          for (let i = 1; i <= route.legs.length - 2; i++) {
            distancetrajet = distancetrajet + route.legs[i].distance.value;
            TimeEstimatedPassager = TimeEstimatedPassager + route.legs[i].duration.value + this.journey.waitTimePassager;
            this.journey.JourneyPassengers[i].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          }
          // 3- Ajouter la distance et la durée pour aller au point destinations
          distancetrajet = distancetrajet + route.legs[route.legs.length - 1].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[route.legs.length - 1].duration.value;

          this.journey.distance = Number((distancetrajet / 1000).toFixed(0));
          this.journey.end = new Date(Number(TimeEstimatedPassager) * 1000);
        }
      } else {
        console.log ('Directions request failed due to ' + status);
      }
    }); */
  }

  routeInfo(origine,destination,waypts,rootNumber){
    return new Promise((resolve,reject) => {
      this.directionsService.route({
          origin: origine,
          destination: destination,
          waypoints: waypts,
          optimizeWaypoints: false,// true
          travelMode: 'DRIVING'
        }, (response, status) => {
          if (status === 'OK') {
            if (rootNumber === 0){
              this.directionsRenderer.setDirections(response);
            } else {
              this.additionalDirectionsRenderer.setDirections(response);
            }
            resolve(response); //obligatoire pour la fct Promise
          } else {
            console.log ('Directions request failed due to ' + status);
            reject(0); //obligatoire pour la fct Promise
          }
        });
    });
  }

  compareOrder( a, b ) {
    if ( a.order < b.order ){
      return -1;
    }
    if ( a.order > b.order ){
      return 1;
    }
    return 0;
  }

  compareTime( a, b ) {
    if ( a.heurePassage < b.heurePassage ){
      return -1;
    }
    if ( a.heurePassage > b.heurePassage ){
      return 1;
    }
    return 0;
  }

    //1- Pour chaque passager on affect une heure de passage
    //2- si le passager n'a pas d'heure de passage on met 00:00
    //3- si on detect q'un passager a plusieur heure, on prend la plus grand et on le tag en orange
    //4- On trie suivant l'heure petit (exp 07:00) au grande (Exp 08:00)
    //5- En suit on ajoute les passagers invalide a la fin avec un tag rouge
  routeOrdreFromHistorique() {
    var JourneyPassengers = this.journey.JourneyPassengers;
    var NewJourneyPassengers = [];
  
    //this.onFilterJourney();
    this.JourneyloadData = true;
    this.positionsJourney = [];

    let params = new HttpParams({
      fromObject: {
        schoolId: this.filter.schoolId + '',
        busIds: JSON.stringify([this.journey.busId]),
        date: moment(this.filterJourney.date).format('YYYY-MM-DD'),
        timeInterval: JSON.stringify(this.filterJourney.timeInterval)
      }
    });
    let url = '/api/bus/mapJourney';

    this.http.get(url, { params })
        .subscribe(
          (data: any) => {

            if (!data.positions.length) {
              this.JourneyloadData = false;
            }

            for (let index = 0; index < data.buses.length; index++) {
              const positions = data.positions.filter(this.getDataFromBus(data.buses[index].id));
              this.positionsJourney = positions;
              if (positions.length > 0) {
                
                NewJourneyPassengers = this.getNewOrder (this.positionsJourney, JourneyPassengers);
                this.journey.JourneyPassengers = [];
                this.journey.JourneyPassengers = NewJourneyPassengers.sort(this.compareOrder); // Sort passager per order generated from historique
                this.refreshMap();
                window.alert('Opération terminée avec succès !');

                const color = '#34495e';
                this.createLineBus(data.buses[index], positions, this.map, color, JourneyPassengers);
              }
            }
            this.JourneyloadData = false;
            //this.map.fitBounds(this.markerBounds);
          },
          error => {
            this.JourneyloadData = false;
          }
        );

  }

  getNewOrder (busPositions, JourneyPassengers){

    let tempDistance = 0;
    let tempPositionsInside = [];
    //var JourneyPassengers = this.journey.JourneyPassengers;

    var passengers = [];
    JourneyPassengers.forEach((journeyPassenger) => {
      passengers.push({
        passengerId: journeyPassenger.Passenger.id,
        lat:  journeyPassenger.Passenger.lat,
        lng: journeyPassenger.Passenger.lng,
        heurePassage: "0000",// hh:mm
        tag: 0 // 0: pas d'heure de passage, 1: une heure de passage, 2: plusieurs heure de passage
      });
    });

    passengers.forEach((passenger, index) => {
      tempPositionsInside = [];
      
      // 1- On cherche positions inside raduis with home position is the center
      for (let i = 0; i < busPositions.length; i++) {

        tempDistance = this.getDistanceInMeter(passenger.lat, passenger.lng,busPositions[i].lat,busPositions[i].lng);
        if (tempDistance < parseInt(this.zoneAnalyze, 10) && busPositions[i].speed < 7){
          tempPositionsInside.push(busPositions[i]);
          //console.log ("Position in ==> "+i);
        }
      }

      // 2- On calcule la durée max
      if (tempPositionsInside.length > 0) {

        passenger.heurePassage = moment.utc(tempPositionsInside[tempPositionsInside.length-1].time).format('HHmm')+'';

        let dt1_string = moment.utc(tempPositionsInside[0].time).format('HH:mm:ss')+'';
        let dt2_string = moment.utc(tempPositionsInside[tempPositionsInside.length-1].time).format('HH:mm:ss')+'';

        let diff_time = this.diffenceTime (dt2_string,dt1_string);

        if (diff_time > (60*15)) { // si la duree est > 15 min
          passenger.tag = 2;
        } else {
          passenger.tag = 1;
        }
      }

    });
    console.log('passengers');
    console.log(passengers);
    passengers.sort(this.compareTime); // Sort passager per time generated from historique
    
    let exist,j;

    for (let i = 0; i < passengers.length; i++) {
      exist = false;
      j = 0;
      while (j < JourneyPassengers.length && exist == false) {
        // console.log('i:'+ i + ' j:'+j+ ' new order:' + waypoint_order[i]+1 + ' old order:' + JourneyPassengers[j].order );
        if (passengers[i].passengerId == JourneyPassengers[j].Passenger.id) {
          JourneyPassengers[j].order = i+1;
          if (passengers[i].tag == 0 ){
            JourneyPassengers[j].color = 'p-red';
          } else if (passengers[i].tag == 2){
            JourneyPassengers[j].color = 'p-orange';
          }
          exist = true;
        }
        j++;
      }
    }
    
    console.log('JourneyPassengers');
    console.log(JourneyPassengers);
    return JourneyPassengers;
  }

  getDistanceInMeter (latCenter, longCenter, lat, lng ){
    return Math.acos( Math.sin(latCenter*Math.PI/180)*Math.sin(lat*Math.PI/180) + Math.cos(latCenter*Math.PI/180)*Math.cos(lat*Math.PI/180)*Math.cos(lng*Math.PI/180-longCenter*Math.PI/180) ) * 6371000;
  }

  diffenceTime (dt2_string,dt1_string){
    let dt1 = new Date();
    let dt2 = new Date();
    let value_dt1 = (dt1_string+":00").split(':');
    let value_dt2 = (dt2_string+":00").split(':');

    dt1.setHours(parseInt(value_dt1[0], 10), parseInt(value_dt1[1], 10), parseInt(value_dt1[2], 10), 0);
    dt2.setHours(parseInt(value_dt2[0], 10), parseInt(value_dt2[1], 10), parseInt(value_dt2[2], 10), 0);

    let diff =(dt2.getTime() - dt1.getTime()) / 1000;

    return Math.abs(Math.round(diff));// difference in second
  }

  updateTotalJourneyPassengers() {
    this.TotalJourneyPassengers = 0;
    this.journey.JourneyPassengers.forEach(journeyPassenger => {
      this.TotalJourneyPassengers = this.TotalJourneyPassengers + journeyPassenger.Passenger.count;
      //console.log("journeyPassenger.Passenger.count", journeyPassenger.Passenger.count);
    });
    //console.log("this.TotalJourneyPassengers", this.TotalJourneyPassengers);
  }

  optimizeAndDisplayRoute(){
    var JourneyPassengers = this.journey.JourneyPassengers;
    var waypts = [];
    JourneyPassengers.forEach((journeyPassenger) => {
      waypts.push({
        location:  new google.maps.LatLng(journeyPassenger.Passenger.lat, journeyPassenger.Passenger.lng),
        stopover: true
      });
    });
    this.directionsService.route({
      origin: { lat: Number(this.journey.startPositionLat), lng: Number(this.journey.startPositionLng) },
      destination: { lat: Number(this.journey.endPositionLat), lng: Number(this.journey.endPositionLng) },
      waypoints: waypts,
      optimizeWaypoints: true,// true
      travelMode: 'DRIVING'
    }, (response, status) => {
      if (status === 'OK') {
        this.directionsRenderer.setDirections(response);
        // Calcule: Temps estimé de fin de trajet / Arrivé a chaque arret / distance total estimé
        if (this.modalOpen !== 'viewJourney' && waypts.length > 0) {
          let route = response.routes[0];
          let exist: boolean;
          let j = 0;
          let NewJourneyPassengers = this.journey.JourneyPassengers;
          var JourneyPassengers = this.journey.JourneyPassengers;

          var waypoint_order = route.waypoint_order;
          //window.alert(waypoint_order);
          // order passager to have the optimized journey
          for (let i = 0; i < waypoint_order.length; i++) {
            exist = false;
            j = 0;
            while (j < JourneyPassengers.length && exist == false) {
              // console.log('i:'+ i + ' j:'+j+ ' new order:' + waypoint_order[i]+1 + ' old order:' + JourneyPassengers[j].order );
              if (waypoint_order[i]+1 == JourneyPassengers[j].order) {
                NewJourneyPassengers[j].order = i+1;
                exist = true;
              }
              j++;
            }
          }
          this.journey.JourneyPassengers = [];
          this.journey.JourneyPassengers = NewJourneyPassengers.sort(this.compareOrder); // Sort passager per order generated from optimization
          this.refreshMap();
          this.optimizationLoading = false;
          this.pnotify.notice({ title: 'Succès', text: 'Optimisation terminée avec succès !' });
        }
      } else {
        console.log ('Directions request failed due to ' + status);
        this.optimizationLoading = false;
        this.pnotify.error({
          title: 'Information',
          text: "Pour avoir l'ordre optimiser, le trajet ne doit pas depassé 25 arrêts \r\nVotre trajet contient " + waypts.length + " arrêts",
          width: '500px',
          addClass: '',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    });
  }

  confirmationForOptimizedRoute() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: "L'ordre de ramassage courant sera remplacé.\n Voulez-vous lancer cette operation ?",
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          focus: false,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.optimizeCurrentBusJourneys();
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  confirmationForHistoriqueRoute() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: "L'ordre de ramassage courant sera remplacé.\n Voulez-vous lancer cette operation ?",
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          focus: false,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.routeOrdreFromHistorique();
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  displayPassagerOutOfJourney(JourneyPassengers) {
    const busIds: any[] = [];
    busIds.push(this.journey.busId);
    const passagersOOJourney: any[] = [];
    let JourneyType: any;
    let exist: boolean;
    let j: any;

    switch (this.journey.type) {
      case 'M1':
        JourneyType = 'Aller';
        break;
      case 'M2':
        JourneyType = 'Retour';
        break;
      case 'AM1':
        JourneyType = 'Aller';
        break;
       case 'AM2':
        JourneyType = 'Retour';
        break;
    }

    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId + '',
        busIds: JSON.stringify(busIds),
        isPositionValide: 'true',
        isAssistant: 'false',
        isActive: 'true'
      }
    });

    this.http.get('/api/passenger/lookup', { params })
      .subscribe(
        (passengers: any) => {
          passengers = passengers.rows.map((passenger) => {
            // window.alert(passenger.lastname);
            return {
              id: passenger.id,
              lastname: passenger.lastname,
              firstnames: passenger.firstnames,
              count: passenger.count,
              subscription: passenger.subscription,
              lat: passenger.lat,
              lng: passenger.lng,
              isAffected: false,
              AffectedBus: ''
            };
          });

          if (passengers.length) {
            // Filtre passager out of journey and have the same journey type
            for (let i = 0; i < passengers.length; i++) {
              exist = false;
              j = 0;
              while (j < JourneyPassengers.length && exist == false) {
                if (passengers[i].id == JourneyPassengers[j].Passenger.id) {
                  exist = true;
                }
                j++;
              }
              //window.alert(passengers[i].lastname);
              //window.alert(passengers[i].subscription);
              if (exist == false && (passengers[i].subscription == 'Aller/Retour' || passengers[i].subscription == JourneyType)){
               passagersOOJourney.push(passengers[i]);
              }
            }
            /* passagersOOJourney.forEach((OOjourneyPassenger) => {
              console.log (OOjourneyPassenger.lastname + ' : ' + OOjourneyPassenger.id);
            }); */

            passagersOOJourney.forEach((OOjourneyPassenger) => {
              Object.keys(this.journeys).forEach((journeyId) => {
                const journey = this.journeys[journeyId];
                /* if (this.journey.id != journey.id &&
                  this.journey.busId == journey.busId && this.journey.day == journey.day && this.journey.type == journey.type) { */
                   if ((journey.J_1 == this.journey.J_1 || journey.J_2 == this.journey.J_2 || journey.J_3 == this.journey.J_3
                    || journey.J_4 == this.journey.J_4 || journey.J_5 == this.journey.J_5) && this.journey.type == journey.type) {

                    journey.JourneyPassengers.forEach((_journeyPassenger) => {
                      if (OOjourneyPassenger.id == _journeyPassenger.Passenger.id) {
                       OOjourneyPassenger.isAffected = true;
                       OOjourneyPassenger.AffectedBus = journey.name;
                      }
                    });
                }
              });
            });
            // Set the markers in the maps for free passagers
            passagersOOJourney.forEach((OOjourneyPassenger) => {
              // console.log (OOjourneyPassenger.lastname + ' is affected ? => ' + OOjourneyPassenger.isAffected);
              this.setMarkerOOjourney(OOjourneyPassenger);
            });
            //console.log("passagersOOJourney",passagersOOJourney);
            this.passagersOutOfJourney = passagersOOJourney;

          }
        }
      );
  }

  onJourneyExport(busId) {
    var assitance = null;
    this.http.get(
      '/api/bus/' + busId
    ).subscribe((bus: any) => {
      if (bus != null) {
        const assistent = bus.Passengers.map((passenger) => {
          if (passenger.isAssistant) {
            //this.assistent = passenger;
            assitance = passenger;
          }
        });
      }
    });
    this.http
      .get('/api/journey/bus/' + busId)
      .subscribe((journeys: any[]) => {
        const doc = new jsPDF();
        let daysNames = [];
        let docName;
        journeys.forEach((journey, idx) => {

          docName = journey.Bus.name;
          daysNames = [];
          if (journey.J_1) {
            daysNames.push('Lundi');
          }
          if (journey.J_2) {
            daysNames.push('Mardi');
          }
          if (journey.J_3) {
            daysNames.push('Mercredi');
          }
          if (journey.J_4) {
            daysNames.push('Jeudi');
          }
          if (journey.J_5) {
            daysNames.push('Vendredi');
          }
          let title = 'Planning du transport';
          var textWidth = doc.getStringUnitWidth(title) * doc.internal.getFontSize() / doc.internal.scaleFactor;
          var titleOffset = (doc.internal.pageSize.width - textWidth) / 2;

          /* let subTitle = '( '+ journey.Bus.School.name + ' )';
              textWidth = doc.getStringUnitWidth(subTitle) * doc.internal.getFontSize() / doc.internal.scaleFactor;
          var subTitleOffset = (doc.internal.pageSize.width - textWidth) / 2; */

          doc.setFontSize(12);
          doc.setFont('', 'bold');
          doc.text(titleOffset, 15, title);
          // doc.setFontSize(10);
          // doc.setFont('', 'normal');
          // doc.text(subTitleOffset, 19, subTitle);

          doc.setFontSize(10);
          doc.setFont('', 'bold');
          doc.text(15, 25, 'Ecole : ');
          doc.text(15, 30, 'Trajet : ');
          doc.text(15, 35, 'Jour(s) : ');
          doc.text(15, 40, 'Type : ');
          doc.text(15, 45, 'Horaire trajet : ');
          doc.text(15, 50, 'Chauffeur : ');
          doc.text(15, 55, 'Accompagnateur : ');
          doc.text(15, 60, 'Nombre d’élève : ');

          doc.setFont('', 'normal');
          doc.text(50, 25, journey.Bus.School.name + '');
          doc.text(50, 30, journey.Bus.name + ' - ' + journey.name);
          doc.text(50, 35, daysNames.join(", ") + '');
          doc.text(50, 40, (journey.type === 'M1' || journey.type === 'AM1' ) ? 'Aller' : 'Retour');
          doc.text(50, 45, this.hourFormat(journey.start) + ' - ' + this.hourFormat(journey.end));
          doc.text(50, 50, (journey.Bus.driverPhone != null) ?
            journey.Bus.driverName + ' ( Tél: ' + journey.Bus.driverPhone + ' )' : journey.Bus.driverName + ' ( Tél: - )');
          //telAssitance =  journey.Bus.hasOwnProperty('Assistant')
          //  && journey.Bus.Assistant != null ? journey.Bus.Assistant.phone + '' : '-';
          //doc.text(50, 55, (journey.Bus.hasOwnProperty('Assistant')
          //  && journey.Bus.Assistant != null) ? journey.Bus.Assistant.name + ' ( Tél: ' + telAssitance + ' )' : '-');
          doc.text(50, 55,(assitance != null) ?
            assitance.lastname + ' ' + assitance.firstnames + ' ( Tél: ' + assitance.phone + ' )': '-');

            const imageData = this.getImageMap(journey);
          // doc.addImage(imageData, 'JPEG', 15, 85, 180, 100);
          const body = [];
          let countPassanger = 0;
          /* journey.JourneyPassengers.forEach(journeyPassenger => {
            body.push([
              journeyPassenger.order,
              journeyPassenger.Passenger.lastname + ' ' + journeyPassenger.Passenger.firstnames,
              this.hourFormat(journeyPassenger.estimatedTime),
              journeyPassenger.Passenger.phone
              //journeyPassenger.Passenger.address
            ]);
            countPassanger = countPassanger + journeyPassenger.Passenger.count;
            //console.log("PDF Timing");
            //console.log(this.hourFormat(journeyPassenger.estimatedTime));
          }); */
          journey.JourneyPassengers.forEach(journeyPassenger => {
            // Splitting first names by '/'
            const firstNames = journeyPassenger.Passenger.firstnames.split('/');
            const registrationNumbers = journeyPassenger.Passenger.registrationNumbers.split('/');
            
            // Pushing each first name separately into the body array
            firstNames.forEach((firstName, i) => { // <-- 'i' will be automatically incremented for each iteration
                body.push([
                    journeyPassenger.order,
                    registrationNumbers[i],
                    journeyPassenger.Passenger.lastname + ' ' + firstName, // Pushing each first name separately
                    this.hourFormat(journeyPassenger.estimatedTime),
                    journeyPassenger.Passenger.phone
                    //journeyPassenger.Passenger.address
                ]);
            });
            
        
            countPassanger = countPassanger + journeyPassenger.Passenger.count;
            //console.log("PDF Timing");
            //console.log(this.hourFormat(journeyPassenger.estimatedTime));
          });
          doc.text(50, 60, countPassanger + '');
          

          doc.autoTable({
            startY: 65, // 190,
            theme: 'striped',
            // tableWidth: 'wrap',
            headStyles: {
              fillColor: '#15a4f7',
              textColor: '#fff'
            },
            //head: [['Order', 'Nom & Prénoms','N° Place', 'Tél', 'Adresse']],
            head: [['Order', 'Matricule', 'Nom & Prénoms', 'Horaire', 'Tél']],
            body: body
          });
          if (idx !== journeys.length - 1) {
            doc.addPage();
          }
        });
        doc.save('trajets-'+docName+'.pdf');
      });
  }
  getImageMap(journey) {
    let imageMap = 'https://maps.googleapis.com/maps/api/staticmap?center=' + journey.Bus.School.lat + ',' + journey.Bus.School.lng
      + '&zoom=13&size=180x100&maptype=roadmap';
    journey.JourneyPassengers.forEach(journeyPassenger => {
      imageMap += '&markers=Clabel:' + journeyPassenger.order
        + '|' + journeyPassenger.Passenger.lat + ',' + journeyPassenger.Passenger.lng;
    });
    imageMap += '&key=AIzaSyD95vF119Pfr10MnHSYR5SRbXYIIeYbsPU';
    return imageMap;
  }

  onPassengerExport(busId, busName) {
    
    const doc = new jsPDF();
    doc.setFontSize(20);
    doc.setFont('', 'bold');
    doc.text(15, 20, 'Reference de bus: ' + busName);
    const body = [];
    const msg = ('Votre code est : ');
    let passengers = [];
    const busIds: any[] = [];
    busIds.push(busId);
    const params = new HttpParams({
      fromObject: {
        busIds: JSON.stringify(busIds),
        isAssistant: 'false',
        isActive: 'true'
      }
    });
    this.http.get(
      '/api/passenger/lookup',
      { params }
    ).subscribe((data: any) => {
      passengers = data.rows.map((passenger) => {
        // window.alert(passenger.lastname);
        return {
          lastname: passenger.lastname,
          firstnames: passenger.firstnames,
          activationKey: passenger.activationKey,
        };
      });

      passengers.forEach(passenger => {
        body.push([
          passenger.lastname,
          passenger.firstnames,
          passenger.activationKey,
          msg + passenger.activationKey
        ]);
      });
      doc.autoTable({
        startY: 30,
        theme: 'striped',
        headStyles: {
          fillColor: '#000',
          textColor: '#fff'
        },
        head: [['nom', 'prénom', 'code','instruction']],
        body: body
      });
      //doc.addPage();
      doc.save('passager.pdf');
    });
    /*
    this.http
      .get('/api/journey/bus/' + busId)
      .subscribe((journeys: any[]) => {
        const doc = new jsPDF();
        journeys.forEach((journey) => {
          doc.setFontSize(20);
          doc.setFont('', 'bold');
          doc.text(15, 20, journey.Bus.School.name + ': ' + journey.Bus.name);
          const body = [];
          const msg = ('votre code est : ');
          journey.JourneyPassengers.forEach(journeyPassenger => {
            body.push([
              journeyPassenger.Passenger.lastname,
              journeyPassenger.Passenger.firstnames,
              journeyPassenger.Passenger.activationKey,
              msg + journeyPassenger.Passenger.activationKey
            ]);
          });
          doc.autoTable({
            startY: 30,
            theme: 'striped',
            headStyles: {
              fillColor: '#000',
              textColor: '#fff'
            },
            head: [['nom', 'prénom', 'code','instruction']],
            body: body
          });
          doc.addPage();
        });
        doc.save('passager.pdf');
      });
      */
  }

  onStartPositionLatLngChange() {
    this.markerStartPosition.setPosition({
      lat: this.journey.startPositionLat,
      lng: this.journey.startPositionLng
    });
    this.markerBounds.extend({ lat: Number(this.journey.startPositionLat), lng: Number(this.journey.startPositionLng) });
  }
  onEndPositionLatLngChange() {
    this.markerEndPosition.setPosition({
      lat: this.journey.endPositionLat,
      lng: this.journey.endPositionLng
    });
    this.markerBounds.extend({ lat: Number(this.journey.endPositionLat), lng: Number(this.journey.endPositionLng) });
  }

  getElapsedSecondsInDay(date) {
    const day = moment(date);
    const startOfDay = day.clone().startOf('day');
    return day.diff(startOfDay, 'seconds');
  }

  // ─── Journey Automation ───────────────────────────────────

  private timeToSeconds(timeStr: string): number {
    const parts = timeStr.split(':');
    return parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60;
  }

  openCreateJourneysModal() {
    this.automationResult = null;
    this.automationLoading = false;
    // Populate bus options
    this.journeyBusOptions = this.buses.map(b => ({ id: b.id, name: b.name }));
    this.journeyConfig.busIds = this.buses.map(b => b.id);
    // Set inscription type defaults based on pre-inscription flag
    if (this.school && this.school.subscriptionOn) {
      this.journeyInscriptionTypeModel = ['new', 'renew'];
    } else {
      this.journeyInscriptionTypeModel = ['-'];
    }
    this.journeyConfig.inscriptionTypes = [...this.journeyInscriptionTypeModel];
    ($('#createJourneysModal') as any).modal('show');
  }

  onJourneyInscriptionTypeChange() {
    this.journeyConfig.inscriptionTypes = [...this.journeyInscriptionTypeModel];
  }

  openOptimizeJourneysModal() {
    this.automationResult = null;
    this.automationLoading = false;
    this.optimizeConfig.busId = 0;
    ($('#optimizeJourneysModal') as any).modal('show');
  }

  executeCreateJourneys() {
    this.automationLoading = true;
    this.automationResult = null;

    const body = {
      schoolId: this.filter.schoolId,
      tripsPerDay: this.journeyConfig.tripsPerDay,
      halfDay: this.journeyConfig.halfDay,
      deleteExisting: this.journeyConfig.deleteExisting,
      times: {
        m1_start: this.timeToSeconds(this.journeyConfig.m1Time),
        m2_start: this.timeToSeconds(this.journeyConfig.m2Time),
        am1_start: this.timeToSeconds(this.journeyConfig.am1Time),
        am2_start: this.timeToSeconds(this.journeyConfig.am2Time)
      },
      busIds: this.journeyConfig.busIds,
      inscriptionTypes: this.journeyConfig.inscriptionTypes
    };

    this.http.post('/api/automation/journeys/create', body)
      .subscribe(
        (result: any) => {
          this.automationResult = result;
          this.automationLoading = false;
          if (result.success) {
            this.initJourneys();
          }
        },
        (error) => {
          this.automationResult = { success: false, error: error.error ? error.error.error : 'Erreur serveur' };
          this.automationLoading = false;
        }
      );
  }

  optimizeCurrentBusJourneys() {
    this.optimizationLoading = true;
    this.optimizeAndDisplayRoute();
  }


  executeOptimizeJourneys() {
    this.automationLoading = true;
    this.automationResult = null;

    const body = {
      schoolId: this.filter.schoolId,
      busId: this.optimizeConfig.busId,
      confirm: true
    };

    this.http.post('/api/automation/journeys/optimize', body)
      .subscribe(
        (result: any) => {
          this.automationResult = result;
          this.automationLoading = false;
          if (result.success) {
            this.initJourneys();
          }
        },
        (error) => {
          this.automationResult = { success: false, error: error.error ? error.error.error : 'Erreur serveur' };
          this.automationLoading = false;
        }
      );
  }

  openUpdateJourneysModal() {
    this.automationResult = null;
    this.automationLoading = false;
    this.journeyBusOptions = this.buses.map(b => ({ id: b.id, name: b.name }));
    this.journeyConfig.busIds = this.buses.map(b => b.id);
    if (this.isClient) {
      // Client : Type d'inscription figé sur "Année en cours"
      this.journeyInscriptionTypeModel = ['-'];
    } else if (this.adminStatus) {
      if (this.school && this.school.subscriptionOn) {
        this.journeyInscriptionTypeModel = ['new', 'renew'];
      } else {
        this.journeyInscriptionTypeModel = ['-'];
      }
    } else {
      this.journeyInscriptionTypeModel = ['-'];
    }
    this.journeyConfig.inscriptionTypes = [...this.journeyInscriptionTypeModel];
    ($('#updateJourneysModal') as any).modal('show');
  }

  executeUpdateJourneys() {
    this.automationLoading = true;
    this.automationResult = null;

    const body = {
      schoolId: this.filter.schoolId,
      busIds: this.journeyConfig.busIds,
      inscriptionTypes: this.journeyConfig.inscriptionTypes
    };

    this.http.post('/api/automation/journeys/update', body)
      .subscribe(
        (result: any) => {
          this.automationResult = result;
          this.automationLoading = false;
          if (result.success) {
            this.initJourneys();
          }
        },
        (error) => {
          this.automationResult = { success: false, error: error.error ? error.error.error : 'Erreur serveur' };
          this.automationLoading = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/planning-and-optimization/journey/journey.component.ts